import CryptoJS from "crypto-js";

const decryptDadosUsuario = (password, email, encrypted) => {
  try {
    const keyIv = CryptoJS.PBKDF2(password, email, {
      keySize: 48 / 4,
      iterations: 1000,
      hasher: CryptoJS.algo.SHA256,
    });
    const key = CryptoJS.lib.WordArray.create(keyIv.words.slice(0, 8));
    const iv = CryptoJS.lib.WordArray.create(keyIv.words.slice(8, 12));
    const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    if (!decryptedText || decryptedText.length === 0) {
      return null;
    }
    return JSON.parse(decryptedText);
  } catch (error) {
    console.error("Erro na descriptografia:", error);
    return null;
  }
};

export default decryptDadosUsuario;
